import { render, staticRenderFns } from "./EditCreateCampainDispociscinesModal.vue?vue&type=template&id=3f642f2d&"
import script from "./EditCreateCampainDispociscinesModal.vue?vue&type=script&lang=js&"
export * from "./EditCreateCampainDispociscinesModal.vue?vue&type=script&lang=js&"
import style0 from "./EditCreateCampainDispociscinesModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardText,VCol,VDialog,VRow})
